<template>
  <div :class="[`view-285-1`, className || ``]">
    <div class="text-101 poppins-normal-storm-dust-14px">Автор</div>
    <div class="group-237"></div>
    <div class="text-124 poppins-medium-black-13px">Александр Петров</div>
  </div>
</template>

<script>
export default {
  name: "View362",
  props: ["className"],
};
</script>

<style>
.view-285-1 {
  display: flex;
  height: 44.25px;
  width: 233px;
}

.text-101 {
  height: 25px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  margin-top: 9px;
  white-space: nowrap;
  width: 42px;
}

.group-237 {
  background-color: var(--alto);
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/image-12-22@2x.png);
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 22.12px;
  height: 44px;
  margin-left: 12px;
  width: 44px;
}

.text-124 {
  height: 20px;
  letter-spacing: 0.26px;
  line-height: normal;
  margin-left: 10px;
  margin-top: 11px;
  width: 121px;
}

.view-285-1.view-292,
.view-285-1.view-293 {
  display: flex;
  height: 44px;
  left: 91px;
  position: absolute;
  top: 323px;
  width: 233px;
}
</style>
